export default {
    appointment: 'Appointment',
    sale: 'Sale',
    roadTest: 'Road Test',
    visit: 'Visit',
    no_objective: 'No objective',
};
